import Vue from "vue";
import Vuex from "vuex";

import CorporateModule from "./corporate_module";
import PackageModule from "./package_module";
import PilotNumberModule from "./pilot_number_module";
import AgentNumberModule from "./agent_number_module";
import MappingNumberModule from "./mapping_number_module";
import VoicemailModule from "./voicemail_module";
import CdrModule from "./cdr_module";
import AuthModule from "./auth_module";
import MlhgModule from "./mlhg_module";
import ReportModule from "./report_module";
import MlhgNumberModule from "./mlhg_number_module";
import CorporateV4Module from "./corporate_v4_module";
import PilotNumberV4Module from "./pilot_number_v4_module";
import AgentNumberV4Module from "./agent_number_v4_module";
import CapacityModule from "./capacity_module";
import EventLogModule from "./eventlog_module";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const modules = {
  Corporate: CorporateModule,
  Package: PackageModule,
  PilotNumber: PilotNumberModule,
  AgentNumber: AgentNumberModule,
  MappingNumber: MappingNumberModule,
  Voicemail: VoicemailModule,
  Cdr: CdrModule,
  Mlhg: MlhgModule,
  MlhgNumber: MlhgNumberModule,
  Auth: AuthModule,
  Report: ReportModule,
  CorporateV4: CorporateV4Module,
  PilotNumberV4: PilotNumberV4Module,
  AgentNumberV4: AgentNumberV4Module,
  Capacity: CapacityModule,
  EventLog: EventLogModule
};

export default new Vuex.Store({
  modules,
  plugins: [
    createPersistedState({
      paths: ["Auth"]
    })
  ]
});
